import { render, staticRenderFns } from "./SaveUmbrellaModal.vue?vue&type=template&id=0fd0cac3&scoped=true&"
import script from "./SaveUmbrellaModal.vue?vue&type=script&lang=ts&"
export * from "./SaveUmbrellaModal.vue?vue&type=script&lang=ts&"
import style0 from "./SaveUmbrellaModal.vue?vue&type=style&index=0&id=0fd0cac3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd0cac3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
